var angular = require('angular');
var _module = require('../index');

if(!window._) _ = require('lodash');

require('angular-google-maps');

_module.requires.push('uiGmapgoogle-maps');

_module.controller('AreaMapController', [
    '$scope',
    'uiGmapGoogleMapApi',

    function($scope, uiGmapGoogleMapApi) {
        $scope.map = {
            center: {
                latitude: $scope.report.coordinates.lat,
                longitude: $scope.report.coordinates.lng
            },
            zoom: 17,
            options: {
                mapTypeControl: false,
                overviewMapControl: false,
                panControl: false,
                streetViewControl: false,
                zoomControl: false,

                mapTypeId: 'satellite'
            }
        };
        $scope.marker = {
            id: 'area-report',
            coords: {
                latitude: $scope.report.coordinates.lat,
                longitude: $scope.report.coordinates.lng
            },
            icon: {
                url: 'http://edge.listreports.com.s3.amazonaws.com/property-assets/map-marker.png?r=10001'
            }
        };

        console.log($scope.marker.icon);
    }
]);